import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/w/$workspaceId/clips')({ component: Outlet });
